import React from 'react';

export default class Basics extends React.Component {

    constructor(props) {
        super(props);

    }



    render() {

        return (
            <div className="guide-page">
                <h3 className="guide-title">Basics</h3>
                <p className="guide-lead">Below are the general guidelines for design and layouts that you should know.</p>

                <p>All input controls should have a floating label. If we dont have a component in the common directory that you need with a floating label, please feel free to create one.</p>
                
                <p>All forms should have a white background.</p>

                <h4>Components</h4>
                <p>All components go in the /common directory. If multiple files are needed for a component, like a scss file for example, then create a new folder for everything to go in and name it the same as the component. When creating components, make sure they are reuseable.</p>
            </div>
        );
    }
}
